import LongProductCard from "../../../../StoreComponents/StoreCard/LongProductCard";
import StoreLoadingSkeleton from "../../../../StoreComponents/StoreLoadingSkeleton";
import { LongCardGrid } from "../components/CardGrid";
import { PreviewHeader } from "../components/Header";
import PreviewWidgetWrapper from "../components/PreviewWidgetWrapper";
import { useFetchBuyAgain } from "./data";
import {
  BUY_IT_AGAIN_LANDING_ROUTE,
  BUY_IT_AGAIN_SUBTITLE,
  BUY_IT_AGAIN_TITLE,
} from "./text";

import { useRef, useEffect } from "react";
import { useInView } from "motion/react";
import PreviewContainer from "../components/PreviewContainer";
import { defaultPreviewLazyLoadConfig } from "../../../../../utils/lazyLoadConfig";

const BuyItAgainPreview = () => {
  const ref = useRef(null);
  const widgetInView = useInView(ref, defaultPreviewLazyLoadConfig);
  const { data, loading, fetchInit } = useFetchBuyAgain({
    pageSize: 8,
    autoInitFetch: false,
  });

  useEffect(() => {
    if (widgetInView) {
      fetchInit();
    }
  }, [widgetInView, fetchInit]);

  if (!loading && data.length === 0) {
    return null;
  }

  return (
    <PreviewWidgetWrapper ref={ref}>
      <PreviewContainer>
        {loading ? (
          <StoreLoadingSkeleton header cardStyle="longCard" row={4} />
        ) : (
          <>
            <PreviewHeader
              title={BUY_IT_AGAIN_TITLE}
              linkTo={BUY_IT_AGAIN_LANDING_ROUTE}
              subtitle={BUY_IT_AGAIN_SUBTITLE}
              indicator="grey"
            />
            <LongCardGrid>
              {data.map((d) => (
                <LongProductCard key={d.stacklineSku} product={d} />
              ))}
            </LongCardGrid>
          </>
        )}
      </PreviewContainer>
    </PreviewWidgetWrapper>
  );
};

export default BuyItAgainPreview;
